import { Component, ElementRef, HostListener, isDevMode, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CartInterface } from '@parts-catalog/services/cart.customer.service';
import { WatchStorageService } from '@parts-catalog/services/watchstorage.service';
import { AuthService } from '@reusable/services/auth/auth.service';
import * as globals from '@reusable/services/globals';

@Component({
  selector: 'store-cart',
  standalone: false,
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss']

})
export class CartComponent implements OnInit {
  cart: CartInterface = JSON.parse(localStorage.getItem('cart'));
  cartCount: number = 0;
  showParts: boolean;
  isDev: any = isDevMode();

  constructor(private watchStorage: WatchStorageService, public router: Router, private eRef: ElementRef, private auth: AuthService) { }

  ngOnInit() {
    this.cartCount =
      this.cart?.stockParts
        ? this.cart.stockParts.length + this.cart.premiumQuotations.length + this.cart.quotaParts.length
        : 0;
    this.watchStorage.watchStorage().subscribe((data: string) => {
      if (data) {
        this.cart = JSON.parse(localStorage.getItem('cart')) || [];
        this.cartCount = 0;
        if (this.cart?.stockParts) {
          this.cartCount = this.cart.stockParts.length + this.cart.premiumQuotations.length + this.cart.quotaParts.length;
        }
      }
    });
  }

  toggleMenu() {
    if (window.screen.width < 768) {
      this.goToCart();
    } else {
      this.showParts = !this.showParts;
    }
  }

  goToCart() {
    if (this.auth.isLoggedIn()) {
      window.location.href = 'https://speero.net/spare-parts/cart/';
    } else {
      this.router.navigate(['/login'], { queryParams: { cart: true } });
    }
    this.showParts = false;
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.showParts = false;
    }
  }
}